module.exports = __webpack_public_path__ + "static/media/IconConfia512x512.5f4c1eb4.png";